import React, { FC, ReactElement, useRef } from "react";
import { Carousel } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import "./CarouselImageSlider.css";

interface CarouselImageSliderProps {
  items: {
       id: number;
        name: string;
        url: string;
        perfumeId?: number;
        }[];
}

const CarouselImageSlider: FC<CarouselImageSliderProps> = ({ items }): ReactElement => {
  const carouselRef = useRef<any>(null);

  return (
    <div className="flipkart-slider">
      <Carousel
        autoplay
        dots
        ref={carouselRef}
        className="flipkart-carousel"
        effect="fade"
      >
        {items.map((item) => (
          <div key={item.id} className="carousel-item-wrapper">
            {/* ✅ Entire image is clickable */}
            <Link to={`/product/${item.perfumeId}`} className="carousel-link">
              <img
                src={item.url}
                alt={item.name}
                className="carousel-image"
              />
            </Link>
          </div>
        ))}
      </Carousel>

      {/* ✅ Arrows on hover */}
      <button
        className="carousel-arrow left"
        onClick={() => carouselRef.current?.prev()}
      >
        <LeftOutlined />
      </button>

      <button
        className="carousel-arrow right"
        onClick={() => carouselRef.current?.next()}
      >
        <RightOutlined />
      </button>
    </div>
  );
};

export default CarouselImageSlider;
